<template>
  <div class='lt-scene_dining-table'>
    <SceneItemTransition transition='slideY-down' :isActive='food === 1'>
      <div class='lt-scene_dining-table_table lt-scene_dining-table_table--1' />
    </SceneItemTransition>

    <SceneItemTransition transition='slideY-down' :isActive='food === 2'>
      <div class='lt-scene_dining-table_table lt-scene_dining-table_table--2' />
    </SceneItemTransition>

    <SceneItemTransition transition='slideY-down' :isActive='food === 3'>
      <div class='lt-scene_dining-table_table lt-scene_dining-table_table--3' />
    </SceneItemTransition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import SceneItemTransition from '../../components/SceneItemTransition';

export default {
  components: {
    SceneItemTransition,
  },
  computed: {
    ...mapFields([
      'scene.status.food',
    ]),
  },
};
</script>

<style lang='scss'>
$img-base: '../../assets';

.lt-scene_dining-table {
  position: absolute;
  left: proportionSize(262, $scene-width);
  bottom: proportionSize(123, $scene-height);
  width: proportionSize(653, $scene-width);
  height: proportionSize(345, $scene-height);
}

.lt-scene_dining-table_table {
  @include scut-absolute(0 0 0 0);
  background: transparent no-repeat bottom center;
  background-size: contain;
  &--1 { background-image: url("#{$img-base}/food-1.svg") }
  &--2 { background-image: url("#{$img-base}/food-2.svg") }
  &--3 { background-image: url("#{$img-base}/food-3.svg") }
}

</style>
